import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ContentUploadInputModule } from 'src/app/content-blocks/components/content-upload-input/content-upload-input.module';
import { TeamCreateComponent } from './team-create.component';
import { LocalFormsModule } from '../local-forms/forms.module';
import { ProgressIndictatorsModule } from '../progress-indicators/progress-indicators.module';
import { ButtonsModule } from '../buttons/buttons.module';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    LocalFormsModule,
    ReactiveFormsModule,
    ProgressIndictatorsModule,
    ButtonsModule,
    ContentUploadInputModule
  ],
  declarations: [
    TeamCreateComponent
  ],
  exports: [
    TeamCreateComponent
  ]
})
export class TeamCreateModule { }
